export async function getWalkthroughCompletion({ client, userId }) {
  if (!client?.queries?.getUserProfile) return false;
  const normalizedUserId = String(userId || "").trim();
  if (!normalizedUserId) return false;

  try {
    const resp = await client.queries.getUserProfile({ cognitoId: normalizedUserId });
    const profile = resp?.data?.getUserProfile || resp?.data || null;
    return Boolean(profile?.walkthroughCompleted);
  } catch (error) {
    console.error("Failed to read walkthrough state:", error);
    return false;
  }
}

export async function markWalkthroughCompleted({ client, userId }) {
  if (!client?.mutations?.setWalkthroughCompletion) return false;
  const normalizedUserId = String(userId || "").trim();
  if (!normalizedUserId) return false;

  try {
    await client.mutations.setWalkthroughCompletion({
      cognitoId: normalizedUserId,
      walkthroughCompleted: true,
    });
    return true;
  } catch (error) {
    console.error("Failed to update walkthrough state:", error);
    return false;
  }
}

export async function hasInitiatedChatRequest({ client, userId }) {
  if (!client?.models?.UserChat?.list) return false;
  const normalizedUserId = String(userId || "").trim();
  if (!normalizedUserId) return false;

  const PK = `CONV#USER#${normalizedUserId}`;
  let nextToken = undefined;

  do {
    const resp = await client.models.UserChat.list({
      filter: { PK: { eq: PK } },
      limit: 200,
      nextToken,
    });

    const { data, errors } = resp ?? {};
    if (errors?.length) {
      throw new Error(errors.map((err) => err.message).join(", "));
    }

    if (Array.isArray(data)) {
      const match = data.some(
        (row) => String(row?.initiated_by || "").trim() === normalizedUserId
      );
      if (match) return true;
    }

    nextToken = resp?.nextToken;
  } while (nextToken);

  return false;
}
